import { useCallback, useContext, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import { SetHubNeedSetup } from "data/hub/actions";

import { useQuery } from "hooks";
import createResolverFactory from "components/QueryClient/ResolverFactory";

import { ToasterContext } from "scenes/Hubly/components/Workspace/Provider";

const factory = () => {
  const query = `mutation setupMyHub($sharedResourceId: ID) {
        setupMyHub(sharedResourceId: $sharedResourceId) {
          successMessage
        }
      }`;

  const resolver = ({ data: { setupMyHub } }) => {
    return setupMyHub;
  };

  return { query: query, resolver: createResolverFactory(resolver) };
};

export function useSetupMyHub() {
  const dispatch = useDispatch();
  const { state } = useLocation();

  const { fireError } = useContext(ToasterContext);
  const { loading, data, error, numOfFetches } = useQuery(
    useCallback(factory, []),
    {
      variables: useMemo(() => {
        return { sharedResourceId: state?.sharedResourceId };
      }, [state]),
    }
  );

  useEffect(() => {
    if (!loading && (data?.successMessage || error?.length))
      dispatch(SetHubNeedSetup(false));
  }, [loading, data, error, dispatch]);

  useEffect(() => {
    if (!loading && error) {
      const errorMessage =
        error[0]?.message || "An error occurred while setting up your hub.";
      console.error(errorMessage);
      fireError(errorMessage, error);
    }
  }, [loading, error, fireError]);

  return {
    loading: loading || (numOfFetches === 0 && !error),
    data: data,
    error: error,
  };
}

export default useSetupMyHub;
